export default "__VITE_ASSET__Das3cMJ8__"